export default __webpack_public_path__ + "static/Performance-b63976338145b70a30f3e80692bac71b.webm";